import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './SocialMediaSection.css'
import fb from "./fb.png";
import wb from "./wb.png";
import ib from "./ib.png";
import yb from "./yb.png";
const SocialMediaSection = () => {
  return (
    <>
    <div className="social-media-section text-center d-flex justify-content-center align-items-center">
      <div className="social-media-content ">
        <div className="container ">
          <div className="row ">
            <div className="col-md-12 ">
              <h4 className='text-white'>"Get the latest news and updates follow us on Facebook and Instagram for real-time insights and exciting offers!"</h4>
            </div>
            <div className="col-md-12">
             <br /><br />
             <a href="https://wa.me/+923222999888" className="mx-4 " target="_blank" rel="noopener noreferrer">
                {/* <i className="fab fa-facebook text-primary "></i> */}
                <img src={wb} alt=""  className='fab' style={{width:"100px",height:"100px",borderRadius:"50%"}}/>
              </a>
              <a href="https://www.facebook.com/www.property92.pk/" className="mx-4 " target="_blank" rel="noopener noreferrer">
                {/* <i className="fab fa-facebook text-primary "></i> */}
                <img src={fb}className='fab'alt="" style={{width:"100px",height:"100px",borderRadius:"50%"}}/>
              </a>
              <a href="https://www.instagram.com/property92.pk/" className="mx-4" target="_blank" rel="noopener noreferrer">
                {/* <i className="fab fa-instagram  ms-5" style={{color:"#E1306C"}}></i> */}
                <img src={ib} className='fab' alt=""style={{width:"100px",height:"100px",borderRadius:"50%"}}/>
              </a>
              <a href="https://www.youtube.com/@Property92-pk" className="mx-2" target="_blank" rel="noopener noreferrer">
                {/* <i className="fab fa-youtube  ms-5"></i> */}
                <img src={yb} className='fab' alt="" style={{width:"100px",height:"100px",borderRadius:"50%"}}/>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default SocialMediaSection;
